import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, BrowserRouter } from 'react-router-dom';
import AllRoutes from './routes/allRoutes';




function App() {
  return (
    <>

        <AllRoutes />
      
    </>
  );
}

export default App;
